import { Box, Button, Card, CardBody, CardFooter, CardHeader, Flex, HStack, Heading, IconButton, Link, Menu, MenuButton, MenuItem, MenuList, Spacer, Text, VStack, Wrap, WrapItem, useToast } from "@chakra-ui/react";
import { NavBar } from "../components/NavBar";
import { Footer } from "../components/Footer";
import React, { useEffect, useRef, useState } from "react";
import { Link as ReactLink, useNavigate } from 'react-router-dom';
import { ViewData } from "../data/ViewData";
import { RoutesData } from "../data/RoutesData";
import { ChainsInfo } from "../data/ChainsInfo";
import { FaSave } from "react-icons/fa";
import { IOUtils } from "../utils/IOUtils";
import { delay } from "../utils/threads";
import { Nervos } from "../visualizer/Nervos";
import { CkbIcon } from "../icons/Icons";

export const NervosPage = () => {
    const isTestnet = !ChainsInfo.useMainnet;
    const [hex64, setHex64] = useState(ViewData.pubKeyHex_Nervos);
    const svgDiv = useRef(null);
    const svgViewer = useRef(null);

    const [svgRendered, setSvgRendered] = useState(false);
    const [minting, setMinting] = useState(false);
    const [minted, setMinted] = useState(ViewData.MintStatus.nervos);
    const [tokenId, setTokenId] = useState("");

    const mintPrice = "365"; // CKB
    const toast = useToast();
    const chainIdName = "Nervos";

    const visualizer: Nervos = new Nervos();
    let svgElement: SVGSVGElement;
    
    const renderSvg = () => {
        if (svgRendered || !svgDiv || !(svgDiv.current)) return;
        svgElement = visualizer.generate(hex64);
        (svgDiv.current as any).appendChild(svgElement);
        setSvgRendered(true);
    }

    const saveSvg = (id: string, collection: string) => {
        const div = document.getElementById(id);
        if (!div) return;
        const svgContent = div.innerHTML;
        const svgString = `<?xml version="1.0" encoding="UTF-8" standalone="no"?> <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"> ${svgContent}`;
        const dataUrl = 'data:image/svg+xml;charset=utf8,' + encodeURIComponent(svgString);
        IOUtils.saveDataURL(dataUrl, "image/svg+xml", `${hex64}.${collection}.svg`);
    }

    const mint = async () => {}

    const withdraw = async () => {}

    return (
        <VStack spacing={4}>
            <NavBar />
            <Wrap></Wrap>
            {minted ? <Card width="340px" m={5}>
                <CardHeader>
                    <Heading size='md'><HStack><CkbIcon/> <Text>Nervos</Text></HStack></Heading>
                </CardHeader>
                <CardBody>
                    <div id="svgViewer" ref={svgViewer} />
                </CardBody>
                <CardFooter>
                    {/* <Button flex='1' variant='ghost' as={Link} target="_blank" href={`https://${openseaPrefix}opensea.io/account`}>OpenSea</Button> */}
                    {/* <Button flex='1' variant='ghost' as={Link} target="_blank" href={`https://explorer.${etherscanPrefix}linea.build/token/${contractAddress}/instance/${tokenId}`}>Etherscan</Button> */}
                </CardFooter>
            </Card> : <Card width="340px" m={5}>
                <CardHeader>
                    <Heading size='md'><HStack><CkbIcon/> <Text>Nervos</Text></HStack></Heading>
                </CardHeader>
                <CardBody>
                    <div id="svgDiv" ref={svgDiv} />
                </CardBody>
                <CardFooter>
                    <Button flex='1' variant='ghost' isDisabled={svgRendered} onClick={renderSvg}>1. Generate</Button>
                    {/* <Menu>
                        <MenuButton as={IconButton} aria-label="Save" title="Save" variant="outline"
                            icon={<FaSave />} isDisabled={!svgRendered} />
                        <MenuList>
                            <MenuItem onClick={e => { saveSvg("svgDiv", `${chainIdName}`); }}>SVG</MenuItem>
                        </MenuList>
                    </Menu> */}
                    <Button flex='1' variant='ghost' isDisabled={true || !svgRendered || minted}
                        isLoading={minting} onClick={mint}>2. Mint (Price: {mintPrice} CKB)</Button>
                </CardFooter>
            </Card>}
            {/* {isDeployer ? <Card width="340px" m={5}>
                <CardHeader>
                    <Heading size='md'>Balance in Contract</Heading>
                </CardHeader>
                <CardBody>
                    <Heading>{balance}</Heading>
                </CardBody>
                <CardFooter>
                    <Button flex='1' variant='ghost' isLoading={withdrawing} onClick={withdraw}>Withdraw</Button>
                </CardFooter>
            </Card> : null} */}
            <Flex>
                <Link as={ReactLink} to={RoutesData.Start}>Mint</Link> &nbsp;on more chains!
            </Flex>
            <Footer />
        </VStack>
    );
}